import { ActionTypes } from "./action-types";

const initialState = {
  loading: false,
  resetToken: null,
  isTokenValid: false,
};

function ResetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        sent: false,
      };
    case ActionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isTokenValid: false,
        resetToken: null,
        loading: false,
      };
    case ActionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case ActionTypes.RESET_PASSWORD_CLEAN_UP:
      return {
        ...state,
        loading: false,
        resetToken: null,
        isTokenValid: false,
      };
    case ActionTypes.VALIDATE_PASSWORD_RESET_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.VALIDATE_PASSWORD_RESET_TOKEN_SUCCESS:
      return {
        ...state,
        isTokenValid: true,
        resetToken: action.payload,
        loading: false,
      };
    case ActionTypes.VALIDATE_PASSWORD_RESET_TOKEN_FAILURE:
      return {
        ...state,
        isTokenValid: false,
        loading: false,
      };
    default:
      return state;
  }
}

export default ResetPasswordReducer;
